<template>
  <div class="circledetail">
    <headd></headd>
    <div class="kv hidden-sm hidden-xs" @click="createpost">
      <img src="../../../static/circle/kv.png" />
    </div>
    <div class="circle_detail container">
      <div
        class="circle_type_detail"
        :style="{
          backgroundImage:
            'url(' + (topic.imgUrl != '' ? topic.imgUrl : moren) + ')',
          backgroundSize: '100% 3.32rem'
        }"
      >
        <div class="ctd_type">#{{ topic.title }}#</div>
        <!-- 	<view class="ctd_title">10月1日直播间，和我们一起探索智慧农业经营新模式！</view> -->
        <div class="ctd_count">
          <div>{{ topic.datanum }}条动态</div>
          <div>
            {{ topic.like_num }}喜欢<img
              class="red"
              src="../../../static/circle/red.png"
            />
          </div>
          ️
        </div>
      </div>
      <circlelist :circletrends="circletrends"></circlelist>
      <div @click="morelist" v-show="!flag">加载更多</div>
    </div>
    <foot></foot>
    <div class="add hidden-lg hidden-md" @click="createpost">发布</div>
  </div>
</template>

<script>
import { getallCircleTrends } from "../api/api"; //引入api里面定义的方法
import circlelist from "../../components/circle-list.vue";
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      type: "",
      topic: {},
      circletrends: [],
      pageindex: 0,
      flag: false,
      search: "",
      moren: "../../static/circle/icon_mr.png"
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    circlelist,
    headd,
    foot
  },
  mounted() {
    this.getCircle();
  },
  methods: {
    createpost() {
      this.$router.push({
        path: "createpost"
      });
      //   uni.navigateTo({
      //     url: "createpost"
      //   });
    },
    async getCircle() {
      var _slef = this;
      var parm = this.$route.query;
      var data = {
        search: _slef.search,
        page: _slef.pageindex,
        type: parm.type,
        limit: 10
      };
      const res = await getallCircleTrends(data);
      _slef.circletrends = _slef.circletrends.concat(
        res.data.data.circletrends
      );
      _slef.topic = res.data.data.topic;

      if (res.data.data.circletrends.length < 10) {
        _slef.flag = true;
      }
    },
    getsearch(value) {
      this.search = value.value;
      (this.circletrends = []),
        (this.pageindex = 1),
        (this.flag = false),
        this.getCircle();
    },
    morelist() {
      if (!this.flag) {
        this.pageindex++;
        this.getCircle();
      }
    }
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #ffffff;
}
.circledetail {
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: 0.3rem auto;
    padding-bottom: 1.2rem;
    .container {
      padding: 0;
    }
  }
}
.kv {
  width: 100%;
  margin-bottom: 0.3rem;
  cursor: pointer;
  img {
    width: 100%;
  }
}
.circle_detail {
  padding: 0 0.32rem 1rem 0.32rem;
  flex-direction: column;

  .circle_type_detail {
    width: 100%;
    height: 3.32rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: flex;

    .ctd_type {
      font-size: 0.3rem;
      color: #ffffff;
      line-height: 0.36rem;
      width: 4.32rem;
      margin-bottom: 0.15rem;
      text-align: center;
      justify-content: center;
      @media (max-width: 991px) {
        font-size: 0.46rem;
        line-height: 0.5rem;
      }
    }

    .ctd_title {
      font-size: 0.22rem;
      color: #ffffff;
      line-height: 0.3rem;
      width: 4.32rem;
      margin-bottom: 0.1rem;
    }

    .ctd_count {
      width: 4.32rem;
      font-size: 0.24rem;
      color: #fff;
      line-height: 0.3rem;
      justify-content: center;
      display: flex;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }

      div {
        margin-right: 0.4rem;

        &:last-child {
          margin-right: 0;
        }

        text {
          color: #ff545a;
        }
        .red {
          margin-left: 0.05rem;
          width: 0.3rem;
          height: 0.3rem;
        }
      }
    }
  }
}

.add {
  position: fixed;
  bottom: 1.4rem;
  left: 50%;
  margin-left: -2.95rem;
  width: 5.9rem;
  height: 0.8rem;
  background: #1395ff;
  border-radius: 0.4rem;
  font-size: 0.3rem;

  color: #ffffff;
  line-height: 0.8rem;
  letter-spacing: 0.03rem;
  z-index: 2;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/circle/circle_detail.vue